import TemplateName from './TemplateName';
import Category from './Category';
import Language from './Language';
import Header from './Header';
import Body from './Body';
import Variables from './Variables';
import AuthMessageContent from './AuthMessageContent';
import Carousel from './Carousel';
import Lto from './Lto';
import Footer from './Footer';
import AuthButtonsText from './AuthButtonsText';
import Buttons from './Buttons';
import MessageValidity from './MessageValidity';
import AuthAppSetup from './AuthAppSetup';

// Render order for the create/edit form (../index.js). Every section takes the same
// {state, dispatch, errors, disabled, isEdit} props regardless of whether it reads all five —
// add a new section by dropping a file in this directory and adding one line here; ../index.js
// itself never needs to change. A section that needs props beyond that common set declares its
// own `extraProps(ctx)` here (ctx = {orgId, channelId, isMmLite}, the values ../index.js has on
// hand) — the render loop stays one generic spread over whatever extraProps returns, so the next
// section that needs outside context doesn't require editing the shell's render loop again.
//
// Order mirrors the console's own (gs-ui-templates' createTemplateForm.tsx:260-280): Header,
// Body, MessageContent, Carousels, Lto, Footer, ButtonsText, Buttons, MessageValidity, AppSetup —
// our AuthAppSetup additionally folds in the console's separate ZeroTapAuthTerms (see
// AuthAppSetup.js's own file-header comment). AuthExtras.js used to render all three Auth cards
// as one section after MessageValidity; it's now split three ways (AuthMessageContent/
// AuthButtonsText/AuthAppSetup) and placed where the console puts each one.
export const SECTIONS = [
  { key: 'templateName', Component: TemplateName },
  { key: 'category', Component: Category },
  { key: 'language', Component: Language },
  { key: 'header', Component: Header },
  { key: 'body', Component: Body },
  { key: 'variables', Component: Variables },
  { key: 'authMessageContent', Component: AuthMessageContent },
  // CarouselSection alone also needs orgId/channelId — it uploads each card's media itself (see
  // Carousel.js's own file-header comment).
  { key: 'carousel', Component: Carousel, extraProps: ({ orgId, channelId }) => ({ orgId, channelId }) },
  { key: 'lto', Component: Lto },
  { key: 'footer', Component: Footer },
  { key: 'authButtonsText', Component: AuthButtonsText },
  // Buttons alone also needs isMmLite — Android deep link's own offer gate, see Buttons.js.
  { key: 'buttons', Component: Buttons, extraProps: ({ isMmLite }) => ({ isMmLite }) },
  { key: 'messageValidity', Component: MessageValidity },
  { key: 'authAppSetup', Component: AuthAppSetup },
];

export { friendlyError } from './errorMessages';
